export const spaceName = 'subscription';
export interface SubscriptionSettings {
  promoCodeInfo?: { valid?: any; percentOff?: any };
  discountedInfo?: { savedAmount?: number; discountedPrice?: number };
}

export default {
  promoCodeInfo: { valid: 'unset', percentOff: 'unset' },
  discountedInfo: {},
} as SubscriptionSettings;
